'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const ReadMore = require('framework/domain/value/readmore');
const ReadMoreView = require('framework/ui/view/readmore');

module.exports = Mn.CollectionView.extend({
    readMoreView: ReadMoreView,
    initialize: function() {
        const orgChildView = this.childView;
        this.childView = function(item) {
            if(item instanceof ReadMore) {
                return this.readMoreView;
            }

            return orgChildView;
        };

        const orgFilter = this.filter;
        this.filter = function(child, index) {
            if(child instanceof ReadMore) {
                return true;
            }

            if(orgFilter) {
                return orgFilter(child, index);
            } else {
                return true;
            }
        };
    }
});



// WEBPACK FOOTER //
// ./framework/ui/view/readmore-collection.js